import { httpService } from '@/api/v1/http.service'
import useMutationWithErrorsHandling from '@/hooks/useMutationWithErrorsHandling'

type SetHiddenColumnsPayload = {
  tableKey: string
  hiddenColumns: string[]
}

const useSetHiddenColumns = ({ onSuccess }: { onSuccess: () => void }) =>
  useMutationWithErrorsHandling({
    mutationFn: (data: SetHiddenColumnsPayload) =>
      httpService.panel.panelUsersTablePreferencesCreate({
        table_key: data.tableKey,
        hidden_columns: data.hiddenColumns
      }),
    onSuccess
  })

export default useSetHiddenColumns
